document.addEventListener('DOMContentLoaded', function () {
  const sliderContainers = document.querySelectorAll('.blog-slider-outer');

  sliderContainers.forEach(container => {
    const slider = container.querySelector('.blog-slider-inner');
    const prevBtn = container.querySelector('.global-prev');
    const nextBtn = container.querySelector('.global-next');
    
    if (!slider) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    // --- Native Physics Touch Drag Mechanics (Smooth on Mobile) ---
    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      slider.style.scrollBehavior = 'auto';
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.style.scrollBehavior = 'smooth';
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.style.scrollBehavior = 'smooth';
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5;
      slider.scrollLeft = scrollLeft - walk;
    });

    // --- Premium Desktop Navigation Interactivity Track Engine ---
    if (nextBtn && prevBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        slider.style.scrollBehavior = 'smooth';
        
        const card = slider.querySelector('.blog-slide-card');
        if (card) {
          const scrollAmount = card.offsetWidth + 32; 
          slider.scrollLeft += scrollAmount;
        }
      });

      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        slider.style.scrollBehavior = 'smooth';
        
        const card = slider.querySelector('.blog-slide-card');
        if (card) {
          const scrollAmount = card.offsetWidth + 32;
          slider.scrollLeft -= scrollAmount;
        }
      });
    }
  });
});